





import { defineComponent } from '@vue/composition-api'
import { openPolicyModal } from '@/store/modules/cookie-consent.store'

export default defineComponent({
  name: 'CookiePolicyLink',
  props: {
    content: {
      type: String,
      required: true
    }
  },
  setup (props, { root }) {
    const store = root.$store

    const onOpenPolicyModal = () => {
      openPolicyModal(store)
    }

    return {
      onOpenPolicyModal
    }
  }
})
